import { FC } from "react"
// import { Tooltip } from "../common/Tooltip"
// import { ArrowDownTrayIcon, PrinterIcon } from "@heroicons/react/24/outline"

export const ActionBar: FC = () => {
  return (
    <div className="card -mt-8 flex items-center justify-between rounded-none py-1.5 md:rounded-b">
      <h2 className="text-lg font-semibold text-gray-900">Dashboard</h2>
      {/* <div className="flex items-center gap-x-2">
        <Tooltip content="Download results">
          <button className="rounded-full p-1.5 text-gray-400 hover:text-gray-700 focus-visible:ring-1 focus-visible:ring-primary-600">
            <ArrowDownTrayIcon className="h-6 w-6 text-inherit" aria-hidden="true" />
            <span className="sr-only">Download results</span>
          </button>
        </Tooltip>

        <Tooltip content="Print">
          <button className="rounded-full p-1.5 text-gray-400 hover:text-gray-700 focus-visible:ring-1 focus-visible:ring-primary-600">
            <PrinterIcon className="h-6 w-6 text-inherit" aria-hidden="true" />
            <span className="sr-only">Print</span>
          </button>
        </Tooltip>
      </div> */}
    </div>
  )
}
